module.exports = __webpack_public_path__ + "img/user.c6a88f73.png";